module.exports = __webpack_public_path__ + "static/media/compPerfomanceIcon.a0ebe99e.svg";